<template>
	<v-sheet outlined rounded class="pa-4">
		<div class="d-flex align-center mb-2">
			<v-icon :color="evaluation.color" class="mr-2">{{ evaluation.icon }}</v-icon>
			<span class="text-subtitle-2">
				Livello di sicurezza: <span :class="evaluation.color + '--text'" class="font-weight-bold">{{ evaluation.label }}</span>
			</span>
			<v-spacer></v-spacer>
			<span class="text-subtitle-2 font-weight-bold" :class="evaluation.color + '--text'">{{ evaluation.score }}%</span>
		</div>
		<v-progress-linear
			:value="evaluation.score"
			:color="evaluation.color"
			height="8"
			rounded
			aria-label="Livello di sicurezza delle regole di accesso"
		></v-progress-linear>
		<div class="text-caption grey--text text--darken-1 mt-2">{{ evaluation.summary }}</div>

		<v-row class="mt-2" dense>
			<v-col v-for="factor in evaluation.factors" :key="factor.key" cols="12" sm="4">
				<div class="d-flex align-start">
					<v-icon small class="mr-2 mt-1" :color="statusColor(factor.status)">{{ statusIcon(factor.status) }}</v-icon>
					<div>
						<div class="text-body-2">{{ factor.title }}</div>
						<div class="text-caption grey--text text--darken-1">{{ factor.detail }}</div>
					</div>
				</div>
			</v-col>
		</v-row>

		<div v-if="evaluation.suggestions.length" class="mt-3">
			<div class="text-caption font-weight-bold mb-1">Per aumentare la sicurezza</div>
			<div v-for="(suggestion, index) in evaluation.suggestions" :key="index" class="d-flex align-start text-caption mb-1">
				<v-icon x-small class="mr-1 mt-1" color="primary">mdi-arrow-up-bold-circle-outline</v-icon>
				<span>{{ suggestion }}</span>
			</div>
		</div>

		<div class="text-caption grey--text mt-3">
			Con i requisiti minimi una password può essere scelta fra circa 10<sup>{{ evaluation.combinationsExponent }}</sup>
			combinazioni ({{ evaluation.bits }} bit). È una stima della robustezza minima garantita dalle regole, non della
			password che ogni utente sceglie davvero.
		</div>
	</v-sheet>
</template>

<script>
import { evaluatePortalSecurity } from './portalPasswordPolicy'

const STATUS = {
	strong: { color: 'success', icon: 'mdi-check-circle' },
	ok: { color: 'light-green', icon: 'mdi-check-circle-outline' },
	weak: { color: 'orange', icon: 'mdi-alert-circle-outline' }
}

export default {
	name: 'PortalSecurityMeter',
	props: {
		policy: Object,
		twofaRequired: Boolean
	},
	computed: {
		evaluation() {
			return evaluatePortalSecurity(this.policy, this.twofaRequired)
		}
	},
	methods: {
		statusColor(status) {
			return STATUS[status].color
		},
		statusIcon(status) {
			return STATUS[status].icon
		}
	}
}
</script>
